import { loadStripe } from '@stripe/stripe-js';
import axios from 'axios';

// API endpoint - Remove trailing slash to avoid double slashes in URLs
const API_URL = (process.env.REACT_APP_API_URL || 'https://camino-backend-iooi.onrender.com').replace(/\/$/, '');
//const API_URL = 'http://localhost:5000';

// Load Stripe
// let stripePromise;
// const getStripe = () => {
//   if (!stripePromise) {
//     stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY);
//   }
//   return stripePromise;
// };

// Retry logic for API calls
const retryApiCall = async (apiCall, maxRetries = 3) => {
  for (let attempt = 1; attempt <= maxRetries; attempt++) {
    try {
      return await apiCall();
    } catch (error) {
      if (attempt === maxRetries) {
        throw error;
      }
      
      // Wait before retry (exponential backoff)
      await new Promise(resolve => setTimeout(resolve, 1000 * attempt));
    }
  }
};

// Create a payment intent
export const createPaymentIntent = async (token, auth0Id) => {
  return retryApiCall(async () => {
    const response = await axios.post(`${API_URL}/api/purchases/create-payment`, {
      package: 'Ajándékcsomag'
    }, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`,
        'X-Auth0-ID': auth0Id
      },
      timeout: 10000 // 10 second timeout
    });
    
    return response.data;
  });
};

// Process payment success
export const processPayment = async (token, paymentIntentId, auth0Id) => {
  return retryApiCall(async () => {
    const response = await axios.post(`${API_URL}/api/purchases/process-payment`, {
      paymentIntentId
    }, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`,
        'X-Auth0-ID': auth0Id
      },
      timeout: 15000 // 15 second timeout for payment processing
    });
    
    return response.data;
  });
};

// Check purchase status
export const checkPurchaseStatus = async (token, auth0Id) => {
  try {
    // Note: Purchase status checking is now disabled as the new backend
    // handles payments differently (via Stripe checkout + webhook)
    console.log('⚠️ Purchase status check disabled - using localStorage fallback');
    
    // Fallback to localStorage for now
    return { hasPurchased: localStorage.getItem('hasPurchased') === 'true' };
  } catch (error) {
    console.error('Error checking purchase status:', error);
    return { hasPurchased: false };
  }
};

// Get certificate
export const getCertificate = async (token, auth0Id) => {
  return retryApiCall(async () => {
    const response = await axios.get(`${API_URL}/api/certificates`, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'X-Auth0-ID': auth0Id
      },
      timeout: 10000
    });
    
    return response.data;
  });
};

// Generate certificate if not exists
export const generateCertificate = async (token, auth0Id) => {
  return retryApiCall(async () => {
    const response = await axios.post(`${API_URL}/api/certificates/generate`, {}, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'X-Auth0-ID': auth0Id
      },
      timeout: 30000 // 30 second timeout for certificate generation
    });
    
    return response.data;
  });
};

// Get QR code
export const getQRCode = async (token, auth0Id) => {
  return retryApiCall(async () => {
    const response = await axios.get(`${API_URL}/api/qrcodes`, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'X-Auth0-ID': auth0Id
      },
      timeout: 10000
    });
    
    return response.data;
  });
};

// Generate QR code if not exists
export const generateQRCode = async (token, auth0Id) => {
  return retryApiCall(async () => {
    const response = await axios.post(`${API_URL}/api/qrcodes/generate`, {}, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'X-Auth0-ID': auth0Id
      },
      timeout: 15000
    });
    
    return response.data;
  });
};